/* eslint-env browser */

/**
 * Infinite Scroll
 * Used on all pages where there is a list of posts (homepage, tag index, etc).
 *
 * When the page is scrolled to 300px from the bottom, the next page of posts
 * is fetched by following the the <link rel="next" href="..."> that is output
 * by {{ghost_head}}.
 *
 * The individual post items are extracted from the fetched pages by looking for
 * a wrapper element with the class "post-card". Any found elements are appended
 * to the element with the class "post-feed" in the currently viewed page.
 */
function captureImages(elements, callBack){
    var allImages = [];

    elements.forEach(function (item) {
        item.querySelectorAll('img').forEach(function(img) {
            allImages.push(img);
        });
    });

    var loadedCount = 0;
    var imageCount = allImages.length;

    if (imageCount > 0) {
        var checkAllLoaded = function () {
            loadedCount++;
            if (loadedCount === imageCount) {
                setTimeout(() => {
                    callBack();
                    document.querySelectorAll('.post > div.invisible').forEach(el => {
                        el.classList.remove('invisible');
                    });
                }, 50);
                
                
            }
        };

        allImages.forEach(function (img) {
            if (img.complete) {
                checkAllLoaded();
            } else {
                img.addEventListener('load', checkAllLoaded);
                img.addEventListener('error', checkAllLoaded);
            }
        });
    }
}

function setHeights(firstRow){
      document.querySelectorAll('.section').forEach(el => {
        const firstEl = el.querySelector('.section-col').querySelectorAll(':scope > div')[firstRow ? 0 : 1];
        console.log(firstEl, firstRow);
        const lastEl = el.querySelector('.section-col:last-child').querySelectorAll(':scope > div')[firstRow ? 0 : 1];
        if (firstEl.offsetHeight > lastEl.offsetHeight) {

            lastEl.style.height = firstEl.offsetHeight + 'px';
        }
        else {

            firstEl.style.height = lastEl.offsetHeight + 'px'
        }
    })  
}
(function (window, document) {
    
    function alignHeights() {
        setTimeout(() => {
            setHeights(true);
            setHeights(false);
            msnry.layout();
        }, 500);

        setTimeout(() => {
            msnry.layout();
        }, 1500);

    }
    alignHeights();
    if (document.documentElement.classList.contains('no-infinite-scroll')) return;

    // next link element
    var nextElement = document.querySelector('link[rel=next]');
    if (!nextElement) {
        return;
    }

    // post feed element
    var feedElement = document.querySelector('#masonry-container');
    if (!feedElement) {
        return;
    }

    var buffer = 300;

    var ticking = false;
    var loading = false;

    var lastScrollY = window.scrollY;
    var lastWindowHeight = window.innerHeight;
    var lastDocumentHeight = document.documentElement.scrollHeight;

    function onPageLoad() {
        if (this.status === 404) {
            window.removeEventListener('scroll', onScroll);
            window.removeEventListener('resize', onResize);
            return;
        }

        // append contents
        var postElements = this.response.querySelectorAll('div.post');
        var posts = [];
        postElements.forEach(function (item) {
            const importedNode = document.importNode(item, true);
            feedElement.appendChild(importedNode);
            
            renderPosts();
            posts.push(importedNode);
            msnry.appended(feedElement.lastElementChild);
        });
        captureImages(posts, function() {
            msnry.layout();
        });
       
        // set next link
        var resNextElement = this.response.querySelector('link[rel=next]');
        if (resNextElement) {
            nextElement.href = resNextElement.href;
        } else {
            window.removeEventListener('scroll', onScroll);
            window.removeEventListener('resize', onResize);
        }

        // sync status
        lastDocumentHeight = document.documentElement.scrollHeight;
        ticking = false;
        loading = false;
        alignHeights();

    }

    function onUpdate() {
        // return if already loading
        if (loading) {
            return;
        }
        lastDocumentHeight = document.documentElement.scrollHeight;

        // return if not scroll to the bottom
        if (lastScrollY + lastWindowHeight <= lastDocumentHeight - buffer) {
            ticking = false;
            return;
        }

        loading = true;

        var xhr = new window.XMLHttpRequest();
        xhr.responseType = 'document';

        xhr.addEventListener('load', onPageLoad);

        xhr.open('GET', nextElement.href);
        xhr.send(null);
    }

    function requestTick() {
        ticking || window.requestAnimationFrame(onUpdate);
        ticking = true;
    }

    function onScroll() {
        lastScrollY = window.scrollY;
        requestTick();
    }

    function onResize() {
        lastWindowHeight = window.innerHeight;
        lastDocumentHeight = document.documentElement.scrollHeight;
        requestTick();
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);

    requestTick();
})(window, document);
